import { render, staticRenderFns } from "./ClientEntity.vue?vue&type=template&id=e0480c70&scoped=true&"
import script from "./ClientEntity.vue?vue&type=script&lang=js&"
export * from "./ClientEntity.vue?vue&type=script&lang=js&"
import style0 from "./ClientEntity.vue?vue&type=style&index=0&id=e0480c70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0480c70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0480c70')) {
      api.createRecord('e0480c70', component.options)
    } else {
      api.reload('e0480c70', component.options)
    }
    module.hot.accept("./ClientEntity.vue?vue&type=template&id=e0480c70&scoped=true&", function () {
      api.rerender('e0480c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientEntity.vue"
export default component.exports